import { Box } from '@mui/material';
import React from 'react';
/**
 * @deprecated replaced by `GlobalApp`, to control scrolling behavior use `FullHeightPage`, do not use together with `GlobalApp` in new code.
 */
export const AppPageHeader = (props) => {
    return (React.createElement(Box, { sx: {
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            height: 84,
            paddingRight: 2,
            paddingLeft: 3,
            backgroundColor: (theme) => theme.palette.background.paper,
            borderBottom: (theme) => '1px solid ' + theme.palette.divider,
            overflow: 'hidden',
        } }, props.children));
};
